import React from 'react';
import styles from './ProductOfferImgWrapper.module.scss';
import classNames from 'classnames';

const ProductOfferImgWrapper = ({ src, shopName, classList = {}, children }) => {
  if (src) return children;

  return (
    <div className={classNames(styles.shopLogoPlaceholder, classList?.shopLogoPlaceholder)}>
      <span>{shopName}</span>
    </div>
  );
};

export default ProductOfferImgWrapper;
